import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroCarousel from "./components/HeroCarousel";
import CategoryNav from "./components/CategoryNav";
import LatestUpdates from "./components/LatestUpdates";
import RankingList from "./components/RankingList";
import FeaturedSection from "./components/FeaturedSection";
import { featuredComics } from "@/mocks/comics";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "韩漫网站-韩漫网站免费在线阅读-漫画免费韩漫网址",
    description:
      "韩漫网站提供免费在线阅读服务，海量无删减韩国漫画资源通过专属网址访问。下拉式界面，每日更新，热门韩漫一站式阅读平台。",
    url: "https://hanmanwu.com/",
    isPartOf: {
      "@type": "WebSite",
      name: "韩漫屋",
      url: "https://hanmanwu.com/",
    },
  };

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: featuredComics.map((comic, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: {
        "@type": "ComicSeries",
        name: comic.title,
        url: `https://hanmanwu.com/comic/${comic.id}`,
        author: { "@type": "Person", name: comic.author },
        description: comic.description,
      },
    })),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "韩漫屋需要付费吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋是韩漫网站免费在线阅读平台，所有漫画资源均免费向用户开放，无需任何付费即可畅享海量韩国漫画内容。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫网站有哪些类型的漫画？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋提供恋爱、奇幻、动作、剧情、搞笑、悬疑、校园、BL、GL、古风等多种类型的韩国漫画，海量资源满足各类读者需求。",
        },
      },
      {
        "@type": "Question",
        name: "如何在手机上观看韩漫？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋采用响应式设计，自动适配手机、平板、电脑等设备。通过漫画免费韩漫网址访问即可享受下拉式阅读体验。",
        },
      },
    ],
  };

  return (
    <>
      <JsonLd data={webPageSchema} />
      <JsonLd data={itemListSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryNav />
        <LatestUpdates />
        <RankingList />
        <FeaturedSection />

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
              韩漫网站免费在线阅读
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              韩漫屋为您提供海量韩国漫画免费在线阅读服务，无删减漫画保证内容完整性，下拉式界面操作简便，每日更新不间断。访问韩漫网站即刻享受专属漫画网址带来的沉浸式阅读体验。
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}